/* eslint-disable max-len */
import 'react';

const SidebarDataSheetSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
    >
        <g fillRule="evenodd">
            <path d="M0 0h16v16H0z" />
            <path
                d="M3.911 2.222h6.222a3.111 3.111 0 013.111 3.111v6.578c0 1.031-.835 1.867-1.866 1.867H4.533a1.867 1.867 0 01-1.866-1.867V3.467c0-.688.557-1.245 1.244-1.245zM7.756 5.845v5.2M10 7.489v3.422M5.556 7.488v3.423"
                stroke="currentColor"
                strokeWidth={0.889}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="0,0"
            />
        </g>
    </svg>
);
export default SidebarDataSheetSvg;
